// DNS record type.

export type DNSRecordType = 'A_RECORD' | 'CNAME_RECORD' | 'CAA_RECORD' | 'AAAA_RECORD';

export interface LookupResponseJSON {
  data: DNSRecordJSON;
}
// JSON-encoded A record.
//
interface ARecordJSON {
  value: string[];
}
// JSON-encoded Cname record.
//
interface CNameRecordJSON {
  value: string;
}
// JSON-encoded CAAValue
//
interface CAAValueJSON {
  value: string;
  issuer_critical_flag: boolean;
  tag: string;
  ttl: number;
  record_class: string;
}
// JSON-encoded CAARecord
interface CAARecordJSON {
  value: CAAValueJSON[];
}
// JSON-encoded AAAA record.
//
interface AAAARecordJSON {
  value: string[];
}
// JSON-encoded DNSRecord
interface DNSRecordJSON {
  domain: string;
  a_record: ARecordJSON;
  cname_record: CNameRecordJSON;
  caa_record: CAARecordJSON;
  aaaa_record: AAAARecordJSON;
}
// Arecord
//
export class ARecord {
  public constructor(public values: string[]) {}
  public static fromJSON(json: DNSRecordJSON): ARecord {
    if (json.a_record !== null) {
      return new ARecord(json.a_record.value);
    } else {
      return new ARecord([]);
    }
  }
}
// CNameRecord
//
export class CNameRecord {
  public constructor(public value: string) {}
  public static fromJSON(json: DNSRecordJSON): CNameRecord {
    if (json.cname_record !== null) {
      return new CNameRecord(json.cname_record.value);
    } else {
      return new CNameRecord(null);
    }
  }
}
// CAAValue
//
export class CAAValue {
  public constructor(
    public value: string,
    public issuerCriticalFlag: boolean,
    public tag: string,
    public ttl: number,
    public recordClass: string,
  ) {}
  public static fromJSON(json: CAAValueJSON): CAAValue {
    return new CAAValue(json.value, json.issuer_critical_flag, json.tag, json.ttl, json.record_class);
  }
}
// CAARecord
//
export class CAARecord {
  public constructor(public values: CAAValue[]) {}
  public static fromJSON(json: DNSRecordJSON): CAARecord {
    if (json.caa_record !== null) {
      const records: CAAValue[] = [];
      for (const value of json.caa_record.value) {
        records.push(CAAValue.fromJSON(value));
      }
      return new CAARecord(records);
    } else {
      return new CAARecord([]);
    }
  }
}
// AAAArecord
//
export class AAAARecord {
  public constructor(public values: string[]) {}
  public static fromJSON(json: DNSRecordJSON): AAAARecord {
    if (json.aaaa_record !== null) {
      return new AAAARecord(json.aaaa_record.value);
    } else {
      return new AAAARecord([]);
    }
  }
}
// DNSRecord
export class DNSRecord {
  public constructor(
    public domain: string,
    public aRecord: ARecord,
    public cnameRecord: CNameRecord,
    public caaRecord: CAARecord,
    public aaaaRecord: AAAARecord,
  ) {}
  public static nullResponseDNSRecord(domain: string): DNSRecord {
    return new DNSRecord(domain, new ARecord([]), new CNameRecord(null), new CAARecord([]), new AAAARecord([]));
  }
  public static fromJSON(json: DNSRecordJSON): DNSRecord {
    const aRecord = ARecord.fromJSON(json);
    const cnameRecord = CNameRecord.fromJSON(json);
    const caaRecord = CAARecord.fromJSON(json);
    const aaaaRecord = AAAARecord.fromJSON(json);
    return new DNSRecord(json.domain, aRecord, cnameRecord, caaRecord, aaaaRecord);
  }
  public isEmpty(): boolean {
    return this.aRecord.values.length === 0 && this.cnameRecord.value === null && this.caaRecord.values.length === 0;
  }
}
